function s(){const s=this;s.support.touch||s.params.watchOverflow&&s.isLocked||s.params.cssMode||(s["container"===s.params.touchEventsTarget?"el":"wrapperEl"].style.cursor="")}export{s as default};
//# sourceMappingURL=unsetGrabCursor.js.map
